import { FormikProps, FormikValues } from 'formik';
import React from 'react';
import Form from '../Form';
import { FormHelpers, FormProps } from '../Form/Form';
import { useSteps } from './hooks';

interface MultiStepFormProps extends FormProps {
  children: React.ReactElement[];
  initialStep?: number;
}

const MultiStepForm = React.forwardRef<FormikProps<FormikValues>, MultiStepFormProps>(
  ({ children, onSubmit, initialStep = 0, ...props }, ref) => {
    const [step, setStep] = React.useState<number>(initialStep);
    const { steps, actions } = useSteps(children);

    React.useEffect(() => {
      setStep(initialStep);
    }, [initialStep]);

    const isLastStep = () => step === steps.length - 1;

    const handleNext = async (values: FormikValues, helpers: FormHelpers) => {
      if (steps[step].props?.onSubmit) {
        try {
          await steps[step].props.onSubmit!(values, helpers);
        } catch (e) {
          return;
        }
      }

      if (!isLastStep()) {
        helpers.setSubmitting(false);
        helpers.enableValidation(false);
        setStep(step + 1);
        return;
      }

      onSubmit(values, helpers);
    };

    return (
      <Form
        validationSchema={steps[step].props.validationSchema}
        onSubmit={handleNext}
        ref={ref}
        {...props}
      >
        {steps[step]}
        {actions}
      </Form>
    );
  },
);

export default MultiStepForm;
